import React from 'react'
import clsx from 'clsx'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import TextLink from '@divvy-web/skylab.textlink'

import { URL } from '@sputnik/resources/constants'

import styles from './style.module.scss'

interface RecaptchaDisclaimerProps {
  onClick?: () => void
}

const RecaptchaDisclaimer = ({ onClick }: RecaptchaDisclaimerProps) => {
  const [getClassName, makeTestId] = useNameFormatter('RecaptchaDisclaimer')
  const { GOOGLE_TERMS_OF_SERVICE, GOOGLE_PRIVACY_POLICY } = URL

  return (
    <div className={clsx(styles[getClassName('')], 'dd-privacy-allow')}>
      <FormattedMessage
        defaultMessage='This site is protected by reCAPTCHA and the Google {privacyPolicy} and {termsOfService} apply.'
        id='sputnik.RecaptchaDisclaimer__2V6H6u'
        values={{
          privacyPolicy: (
            <TextLink
              dataTestId={makeTestId('privacy-policy-link')}
              href={GOOGLE_PRIVACY_POLICY}
              target='_blank'
            >
              <FormattedMessage
                defaultMessage='Privacy Policy'
                id='sputnik.RecaptchaDisclaimer__vx0nkZ'
              />
            </TextLink>
          ),
          termsOfService: (
            <TextLink
              dataTestId={makeTestId('terms-of-service-link')}
              href={GOOGLE_TERMS_OF_SERVICE}
              target='_blank'
              onClick={onClick}
            >
              <FormattedMessage
                defaultMessage='Terms of Service'
                id='sputnik.RecaptchaDisclaimer__32rBNK'
              />
            </TextLink>
          ),
        }}
      />
    </div>
  )
}

export default RecaptchaDisclaimer
